import { AlertCircle, Check, Loader } from 'lucide-react';
import type { ReactNode } from 'react';
import { formatTime } from '../../../lib/format';
import type { SaveState } from '../hooks/use-step-autosave';
import styles from './SaveIndicator.module.css';

/**
 * 06-qol §4: "a visible Saved indicator and timestamp". Feedback stays on this line
 * and nowhere else — nothing on the page flinches while a step saves (§5a rule 4).
 */
export function SaveIndicator({ state }: { readonly state: SaveState }): ReactNode {
  switch (state.kind) {
    case 'idle':
      return <span className={styles.indicator}>Changes save as you go</span>;
    case 'pending':
    case 'saving':
      return (
        <span className={styles.indicator} role="status">
          <Loader size={14} aria-hidden className={styles.spin} />
          Saving
        </span>
      );
    case 'saved':
      return (
        <span className={styles.indicator} role="status" data-tone="success">
          <Check size={14} aria-hidden />
          Saved {formatTime(state.at)}
        </span>
      );
    case 'error':
      return (
        <span className={styles.indicator} role="alert" data-tone="danger">
          <AlertCircle size={14} aria-hidden />
          Not saved: {state.message}
        </span>
      );
  }
}
